import React, { useState } from "react";
import {
    Table, TableHead, TableRow, TableCell, TableBody, Paper, Button, Typography,
    Box, Chip, Modal, TextField, IconButton, InputAdornment, CircularProgress, Tooltip, MenuItem,
    FormControl,
    Select,
    InputLabel,
    Grid,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import axios from "axios";
import baseURL from "../../config";
import { Edit as EditIcon, Search as SearchIcon } from "@mui/icons-material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransferVesselModal from "./TransferVesselModal";
import WarningIcon from '@mui/icons-material/Warning';
import * as XLSX from "xlsx";
import { jwtDecode } from "jwt-decode";


const SignOnModal = ({ signonDetails }) => {
    const [open, setOpen] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const [selectedContractId, setSelectedContractId] = useState(null);
    const [contractopenModal, setContractopenModal] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [crewMeta, setCrewMeta] = useState({ name: "", indos: "" });
    const [formData, setFormData] = useState({
        portName: "",
        portCountry: "",
        date: "",
        cdcStamppageFile: "",
        passport: "",
        salaryclose: "",
    });

    const userID = localStorage.getItem("user id");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedCrewName, setSelectedCrewName] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [editingId, setEditingId] = useState(null);
    const [newDate, setNewDate] = useState("");

    const months = [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' },
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

    // Assuming token is stored in localStorage
    const token = localStorage.getItem("token");

    let userEmail = "";
    if (token) {
        try {
            const decoded = jwtDecode(token); // ✅ use jwtDecode, not jwt_decode
            userEmail = decoded.email;        // get email from token
        } catch (error) {
            console.error("Invalid token:", error);
        }
    }

    const ChangeSignOnDate = async (SignonId) => {
        try {
            if (!newDate) return alert("Please select a new date!");

            const response = await axios.put(
                `${baseURL}/api/updateSignOnDateByEmail/${SignonId}`,
                { newDate },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                alert("✅ Sign-On date updated successfully!");
                setEditingId(null);
                setNewDate("");
                window.location.reload();
            } else {
                alert("⚠️ Failed to update date.");
            }
        } catch (error) {
            console.error("❌ Error updating SignOn date:", error);
            alert(error.response?.data?.message || "Internal server error");
        }
    };




    const handleOpen = (contract, crewName) => {
        setSelectedContract(contract);
        setSelectedCrewName(crewName);
        setOpen(true);
        setFormData({
            portName: "",
            portCountry: "",
            date: "",
        });

    };

    const handleClose = () => {
        setOpen(false);
        setSelectedContract(null);
        setFormData({
            portName: "",
            portCountry: "",
            date: "",
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData((prev) => ({
                ...prev,
                [name]: {
                    originalName: files[0].name,
                    file: files[0], // you can access this when uploading
                },
            }));
        }
    };

    const getContractRemainingDays = (startDateStr, durationInMonths) => {
        if (!startDateStr || !durationInMonths) return null;

        const startDate = new Date(startDateStr);
        const endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + parseInt(durationInMonths));

        const today = new Date();

        if (endDate <= today) return "Contract Ended";

        let remainingMonths = (endDate.getFullYear() - today.getFullYear()) * 12 +
            (endDate.getMonth() - today.getMonth());

        let adjustedEnd = new Date(today);
        adjustedEnd.setMonth(adjustedEnd.getMonth() + remainingMonths);

        // If adjustedEnd goes past the actual endDate, reduce a month
        if (adjustedEnd > endDate) {
            remainingMonths--;
            adjustedEnd.setMonth(adjustedEnd.getMonth() - 1);
        }

        // Now calculate the remaining days
        const remainingDays = Math.ceil((endDate - adjustedEnd) / (1000 * 60 * 60 * 24));

        const months = remainingMonths;
        const days = remainingDays;

        let result = [];
        if (months) result.push(`${months} month${months > 1 ? "s" : ""}`);
        if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);

        return `Contract remaining : ${result.join(" ")} `;
    };

    const handleSave = async () => {
        const { portName, portCountry, date, cdcStamppageFile, passport, salaryclose } = formData;

        if (!portName || !portCountry || !date || !cdcStamppageFile || !passport || !salaryclose) {
            toast.error("All fields are required.");
            return;
        }

        if (!selectedContract) {
            toast.error("No contract selected!");
            return;
        }



        setLoading(true);

        const token = localStorage.getItem("token");

        const dataToSend = new FormData();

        // Append basic text data
        dataToSend.append("creatorId", userID);
        dataToSend.append("crewId", selectedContract.contractDetails?.crewDetails?._id || "");
        dataToSend.append("contractId", selectedContract.contractDetails?._id || "");

        // Prepare signOff metadata only (without files)
        const signOffData = [
            {
                date: formData.date,
                portName: formData.portName,
                portCountry: formData.portCountry,
            }
        ];
        dataToSend.append("signOff", JSON.stringify(signOffData));

        // Append files with nested keys
        if (formData.cdcStamppageFile?.file) {
            dataToSend.append("signOff[0][cdcStamppageFile]", formData.cdcStamppageFile.file);
        }

        if (formData.passport?.file) {
            dataToSend.append("signOff[0][passport]", formData.passport.file);
        }

        if (formData.salaryclose?.file) {
            dataToSend.append("signOff[0][salaryclose]", formData.salaryclose.file);
        }

        try {
            const response = await axios.post(`${baseURL}/api/statusAfterForm1`, dataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success("Data saved successfully!");
            handleClose();

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error("Error saving data:", error.response?.data || error.message);
            toast.error("Failed to save data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const getRemainingDays = (dateStr) => {
        if (!dateStr) return null;
        const cocDate = new Date(dateStr);
        const today = new Date();
        const diffTime = today - cocDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const remaining = 30 - diffDays;
        return remaining > 0 ? remaining : 0;
    };



    const handleOpenSignOnFiles = ({ signOnData, name, indos }) => {
        if (!signOnData) {
            console.error("Sign-On data is missing");
            return;
        }
        const documents = [];

        if (signOnData.cdcStamppageFile?.filePath) {
            documents.push({
                name: "CDC Stamp Page",
                filePath: `${baseURL}/${signOnData.cdcStamppageFile.filePath.replace(/\\/g, "/")}`,
            });
        }

        if (signOnData.ImoCrewListFile?.filePath) {
            documents.push({
                name: "IMO Crew List",
                filePath: `${baseURL}/${signOnData.ImoCrewListFile.filePath.replace(/\\/g, "/")}`,
            });
        }

        setCrewMeta({ name, indos });
        setSelectedDocuments(documents);
        setOpenModal(true);
    };


    const handleTransfer = (contractId) => {
        setSelectedContractId(contractId);
        setContractopenModal(true);
    };

    // Search Filter Logic
    const filteredContracts = signonDetails?.filter(contract => {
        const vesselName = contract.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
        const crewName = contract.contractDetails?.crewdetails?.name?.toLowerCase() || "";
        const agentName = contract.contractDetails?.crewingAgent?.agentName?.toLowerCase() || "";
        const indos = contract.contractDetails?.crewdetails?.indosno?.toLowerCase() || "";
        return (
            vesselName.includes(searchQuery.toLowerCase()) ||
            crewName.includes(searchQuery.toLowerCase()) ||
            agentName.includes(searchQuery.toLowerCase()) ||
            indos.includes(searchQuery.toLowerCase())
        );
    });

    const filteredCocData = filteredContracts.filter((row) => {
        // If no date is selected, show all records (or apply month/year filters if needed)
        if (!selectedDate) {
            // Apply month/year filters if they exist
            const cocDateRaw = row.contractStatusAfterForm1?.signOn?.[0]?.date;
            if (!cocDateRaw) return false;

            const cocDate = new Date(cocDateRaw);
            const month = String(cocDate.getMonth() + 1).padStart(2, '0');
            const year = String(cocDate.getFullYear());

            return (
                (!selectedMonth || month === selectedMonth) &&
                (!selectedYear || year === String(selectedYear))
            );
        }

        // If date is selected, filter ONLY by Added SignOn date
        const addedSignOnDateRaw = row.contractStatusAfterForm1?.signOn?.[0]?.creatorIdWithName?.[0]?.createdAt;
        if (!addedSignOnDateRaw) return false;

        const addedSignOnDate = new Date(addedSignOnDateRaw);
        const dateOnly = addedSignOnDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD

        return dateOnly === selectedDate;
    });

    // console.log("filteredCocData", filteredCocData)
    const handleExportToExcel = () => {
        const dataToExport = filteredCocData.map((item, index) => {
            const cocDate = item.contractStatusAfterForm1?.coc?.[0]?.Date;
            const formattedCocDate = cocDate
                ? new Date(cocDate).toLocaleDateString("en-GB")
                : "N/A";

            const signOnDate = item.contractStatusAfterForm1?.signOn?.[0]?.date;
            const formattedSignOnDate = signOnDate
                ? new Date(signOnDate).toLocaleDateString("en-GB")
                : "N/A";

            const duration = item.contractDetails?.contractDuration;
            const contractRemaining = getContractRemainingDays(cocDate, duration);

            const signOnCreator = item.contractStatusAfterForm1?.signOn?.[0]?.creatorIdWithName?.[0]?.name || "N/A";
            const signOnCreatedAt = item.contractStatusAfterForm1?.signOn?.[0]?.creatorIdWithName?.[0]?.createdAt;
            const formattedSignOnCreatedAt = signOnCreatedAt
                ? new Date(signOnCreatedAt).toLocaleDateString("en-GB").replace(/\//g, "-")
                : "N/A";

            return {
                "Sr No.": index + 1,
                "Vessel Name": item.contractDetails?.ShipDetails?.vesselname || "N/A",
                "Transferred Vessel Name": item.contractDetails?.transferedAfterSignOnVesselName || "N/A",
                "Company": item.contractDetails?.vesselOwner?.company_shortname || "N/A",
                "Crew Name": item.contractDetails?.crewdetails?.name || "N/A",
                "Indos No.": item.contractDetails?.crewdetails?.indosno || "N/A",
                "Agent": item.contractDetails?.crewingAgent?.agentName || "N/A",
                "COC Date": formattedCocDate,
                "SignOn Date": formattedSignOnDate,
                //   "Remaining SignOn Days": getRemainingDays(cocDate),
                //   "Contract Remaining": contractRemaining,
                //   "SignOn Added By": signOnCreator,
                //   "SignOn Added Date": formattedSignOnCreatedAt
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "COC & SignOn Details");

        XLSX.writeFile(workbook, "COC_SignOn_Details.xlsx");
    };

    return (
        <>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box
                    sx={{
                        p: 1,
                        bgcolor: "primary.main",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "nowrap", // ensures single line
                        gap: 0,
                    }}
                >
                    {/* Search Bar */}
                    <TextField
                        placeholder="Search by vessel, crew, or agent name..."
                        variant="outlined"
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="primary" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            bgcolor: "#f5f5f5",
                            borderRadius: 2,
                            width: 300,
                            mr: 1,
                        }}
                    />

                    {/* Title */}
                    <Typography
                        variant="h6"
                        component="h2"
                        fontWeight="500"
                        sx={{ whiteSpace: "nowrap", mx: 1 }}
                    >
                        Vessel sign on
                    </Typography>

                    {/* Filters: Month & Year */}
                    <Box sx={{ display: "flex", gap: 1, mx: 1 }}>
                        <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, minWidth: 120 }}>
                            <InputLabel>Month</InputLabel>
                            <Select
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                                label="Month"
                            >
                                <MenuItem value="">All Months</MenuItem>
                                {months.map((m) => (
                                    <MenuItem key={m.value} value={m.value}>
                                        {m.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, minWidth: 100 }}>
                            <InputLabel>Year</InputLabel>
                            <Select
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                                label="Year"
                            >
                                <MenuItem value="">All Years</MenuItem>
                                {years.map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            size="small"
                            type="date"
                            label="Filter by Added SignOn Date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                bgcolor: "white",
                                color: '#c62828',
                                borderRadius: 1,
                                minWidth: 200,
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: 'white',
                                }
                            }}
                        />

                        <Button
                            onClick={() => {
                                setSelectedMonth('');
                                setSelectedYear('');
                                setSelectedDate('');
                            }}
                            variant="outlined"
                            size="small"
                            sx={{
                                color: 'white',
                                borderColor: 'white',
                                '&:hover': {
                                    borderColor: 'white',
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                            }}
                        >
                            Clear Filters
                        </Button>

                        <Button
                            onClick={handleExportToExcel}
                            variant="contained"
                            sx={{
                                width: 180,
                                height: 40,
                                backgroundColor: '#2e7d32',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1b5e20',
                                },
                            }}
                        >
                            Export to Excel
                        </Button>
                    </Box>

                    {/* Total Count */}
                    <Typography
                        variant="h6"
                        component="h2"
                        fontWeight="500"
                        sx={{ whiteSpace: "nowrap", ml: 1 }}
                    >
                        Total Count: {filteredCocData.length}
                    </Typography>
                </Box>




                {/* Table Displaying Contract Details */}
                {Array.isArray(filteredCocData) && filteredCocData.length > 0 ? (
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Sr. No.</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Contract Details</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Documents</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>Action</TableCell>
                                <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: "bold" }}>ScreenShot</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredCocData.length > 0 ? (
                                filteredCocData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((contract, index) => {
                                        const cocDate = contract.contractStatusAfterForm1?.coc?.[0]?.Date;
                                        const duration = contract.contractDetails?.contractDuration;
                                        const contractRemainingLabel = getContractRemainingDays(cocDate, duration);

                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                <TableCell>
                                                    {/* {console.log(contract)} */}
                                                    <Box display="flex" flexDirection="row" gap={4} mb={1}>
                                                        <Typography variant="subtitle2" fontWeight="bold">
                                                            <strong style={{ color: "black" }}>Vessel Name: {contract.contractDetails?.ShipDetails?.vesselname || "N/A"}</strong>
                                                        </Typography>
                                                        <Typography variant="subtitle2" fontWeight="bold">
                                                            <strong style={{ color: "#2e7d32" }}>
                                                                Company Name: {contract.contractDetails?.vesselOwner?.company_shortname || "N/A"}
                                                            </strong>
                                                        </Typography>
                                                        {contract.contractDetails?.transferedAfterSignOnVesselName && (
                                                            <Typography variant="subtitle2" fontWeight="bold">
                                                                <strong style={{ color: "black" }}>Transferred Vessel Name:</strong>{" "}
                                                                {contract.contractDetails.transferedAfterSignOnVesselName}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                                        <Chip
                                                            size="small"
                                                            label={`Crew: ${contract.contractDetails?.crewdetails?.name || "N/A"}`}
                                                            sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }}
                                                        />
                                                        <Chip
                                                            size="small"
                                                            label={`Indos No.: ${contract.contractDetails?.crewdetails?.indosno || "N/A"}`}
                                                            sx={{ bgcolor: "#fff9c4", color: "#f57f17" }}
                                                        />
                                                        <Chip
                                                            size="small"
                                                            label={`Agent: ${contract.contractDetails?.crewingAgent?.agentName || "N/A"}`}
                                                            sx={{ bgcolor: "#f3e5f5", color: "#6a1b9a" }}
                                                        />
                                                        <Chip
                                                            size="small"
                                                            label={`COC Date: ${contract.contractStatusAfterForm1?.coc?.[0]?.Date
                                                                ? new Date(contract.contractStatusAfterForm1.coc[0].Date).toLocaleDateString("en-GB", {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                })
                                                                : "N/A"
                                                                }`}
                                                            sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                                                        />
                                                        {/* {console.log("contract.contractStatusAfterForm1", contract.contractStatusAfterForm1)} */}
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            {/* <Chip
                                                                size="small"
                                                                label={`SignOn Date: ${contract.contractStatusAfterForm1?.signOn?.[0]?.date
                                                                    ? new Date(contract.contractStatusAfterForm1.signOn[0].date).toLocaleDateString("en-GB", {
                                                                        day: "2-digit",
                                                                        month: "2-digit",
                                                                        year: "numeric",
                                                                    })
                                                                    : "N/A"
                                                                    }`}
                                                                sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                                                            /> */}
                                                            {/* Show date or editable input */}
                                                            {editingId === contract?.contractStatusAfterForm1?._id && userEmail === "neeturashmi@gmail.com" ? (
                                                                <>
                                                                    <TextField
                                                                        type="date"
                                                                        value={newDate}
                                                                        onChange={(e) => setNewDate(e.target.value)}
                                                                        size="small"
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        onClick={() =>
                                                                            ChangeSignOnDate(contract?.contractStatusAfterForm1?._id)
                                                                        }
                                                                        disabled={!newDate}
                                                                    >
                                                                        Save
                                                                    </Button>
                                                                    <Button
                                                                        variant="outlined"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setEditingId(null);
                                                                            setNewDate("");
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Chip
                                                                        size="small"
                                                                        label={`SignOn Date: ${contract?.contractStatusAfterForm1?.signOn?.[0]?.date
                                                                            ? new Date(contract.contractStatusAfterForm1.signOn[0].date)
                                                                                .toLocaleDateString("en-GB", {
                                                                                    day: "2-digit",
                                                                                    month: "2-digit",
                                                                                    year: "numeric",
                                                                                })
                                                                            : "N/A"
                                                                            }`}
                                                                        sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                                                                    />
                                                                    {userEmail === "neeturashmi@gmail.com" && (
                                                                        <Tooltip title="Edit SignOn Date">
                                                                            <IconButton
                                                                                size="small"
                                                                                color="primary"
                                                                                onClick={() => {
                                                                                    setEditingId(contract?.contractStatusAfterForm1?._id);
                                                                                    setNewDate(
                                                                                        contract.contractStatusAfterForm1?.signOn?.[0]?.date
                                                                                            ? new Date(contract.contractStatusAfterForm1.signOn[0].date)
                                                                                                .toISOString()
                                                                                                .split("T")[0]
                                                                                            : ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <EditIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    )}
                                                                </>
                                                            )}

                                                        </Box>
                                                        {contractRemainingLabel && (
                                                            <Chip
                                                                size="medium"
                                                                icon={
                                                                    contractRemainingLabel === "Contract Ended" ? (
                                                                        <WarningIcon sx={{ color: "#b71c1c" }} />
                                                                    ) : (
                                                                        <HourglassEmptyIcon sx={{ color: "#0277bd" }} />
                                                                    )
                                                                }
                                                                label={contractRemainingLabel}
                                                                sx={{
                                                                    bgcolor: contractRemainingLabel === "Contract Ended" ? "#ffebee" : "#e1f5fe",
                                                                    color: contractRemainingLabel === "Contract Ended" ? "#b71c1c" : "#01579b",
                                                                    fontWeight: "bold",
                                                                    borderRadius: 2,
                                                                    px: 2,
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                                    userSelect: "none",
                                                                    minWidth: 180,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                }}
                                                            />
                                                        )}
                                                        {/* {console.log("contract?.contractStatusAfterForm1", contract?.contractStatusAfterForm1)} */}
                                                        {contract?.contractStatusAfterForm1?.signOn?.[0]?.creatorIdWithName?.length > 0 && (
                                                            <Chip
                                                                size="small"
                                                                label={`Added SignOn: ${contract.contractStatusAfterForm1.signOn[0].creatorIdWithName[
                                                                    contract.contractStatusAfterForm1.signOn[0].creatorIdWithName.length - 1
                                                                ].name
                                                                    } - ${new Date(
                                                                        contract.contractStatusAfterForm1.signOn[0].creatorIdWithName[
                                                                            contract.contractStatusAfterForm1.signOn[0].creatorIdWithName.length - 1
                                                                        ].createdAt
                                                                    )
                                                                        .toLocaleDateString("en-GB")
                                                                        .replace(/\//g, "-")}`}
                                                                sx={{ bgcolor: "#ffebee", color: "#c62828" }}
                                                            />
                                                        )}



                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    {/* {console.log("contract", contract)} */}
                                                    {/* Check if any signOn file exists */}
                                                    {contract.contractStatusAfterForm1?.signOn?.[0] && (
                                                        <>
                                                            {(contract.contractStatusAfterForm1.signOn[0].cdcStamppageFile?.filePath ||
                                                                contract.contractStatusAfterForm1.signOn[0].ImoCrewListFile?.filePath) && (
                                                                    <IconButton
                                                                        onClick={() => handleOpenSignOnFiles({
                                                                            signOnData: contract?.contractStatusAfterForm1.signOn[0],
                                                                            name: contract?.contractDetails?.crewdetails?.name || "N/A",
                                                                            indos: contract?.contractDetails?.crewdetails?.indosno || "N/A",
                                                                        })}
                                                                    >
                                                                        <PictureAsPdfIcon sx={{ color: "red" }} />
                                                                    </IconButton>
                                                                )}
                                                        </>
                                                    )}
                                                </TableCell>

                                                <TableCell>
                                                    <IconButton variant="contained" color="primary" onClick={() => handleOpen(contract, contract.contractDetails?.crewdetails?.name || "N/A")}>
                                                        <EditIcon />
                                                    </IconButton>

                                                    <Tooltip title="Transfer Vessel">
                                                        <IconButton
                                                            onClick={() => handleTransfer(contract.contractDetails?._id)}
                                                            color="secondary"
                                                        >
                                                            <SwapHorizIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                    {contract?.ssDocuments?.signon?.length > 0 && (
                                                        <>
                                                            {contract.ssDocuments.signon.map((docItem, docIndex) => (
                                                                <Tooltip title="ScreenShot" key={docIndex}>
                                                                    <IconButton
                                                                        onClick={() => window.open(`${baseURL}/${docItem.ssDocument?.filePath}`, "_blank")}
                                                                    >
                                                                        <PictureAsPdfIcon sx={{ color: "red" }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ))}
                                                        </>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={2}>
                                        <Typography variant="h6" align="center">No Matching Results</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                ) : (
                    <Typography variant="h6" gutterBottom>No Sign-On Details Found</Typography>
                )}
            </Paper>

            <TransferVesselModal
                open={contractopenModal}
                onClose={() => setContractopenModal(false)}
                contractId={selectedContractId}
            />
            {/* Modal to Enter Sign-On Details */}
            <Modal open={open} onClose={handleClose}>
                <Paper
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        p: 3,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Enter Sign-Off: {" "}
                        {selectedCrewName && (
                            <span style={{ color: "green" }}> {selectedCrewName}</span>
                        )}
                    </Typography>
                    <TextField
                        fullWidth
                        required
                        label="Port Name"
                        name="portName"
                        value={formData.portName}
                        onChange={handleChange}
                        margin="dense"

                    />
                    <TextField
                        fullWidth
                        required
                        label="Port Country"
                        name="portCountry"
                        value={formData.portCountry}
                        onChange={handleChange}
                        margin="dense"

                    />
                    {/* <TextField
                        fullWidth
                        required
                        label="Date"
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        inputProps={{
                            max: new Date().toISOString().split("T")[0],
                        }}

                    /> */}
                    <TextField
                        fullWidth
                        required
                        label="Sign Off Date"
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        inputProps={{
                            min:
                                selectedContract?.contractStatusAfterForm1?.signOn?.[0]?.date
                                    ? new Date(
                                        selectedContract.contractStatusAfterForm1.signOn[0].date
                                    )
                                        .toISOString()
                                        .split("T")[0]
                                    : undefined, // prevent crash if no date yet
                            max: new Date().toISOString().split("T")[0],
                        }}
                    />


                    {/* File Upload: cdc Stamp page File Page */}
                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            CDC
                        </Typography>
                        <label htmlFor="cdc-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="cdc-upload"
                                type="file"
                                name="cdcStamppageFile"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.cdcStamppageFile?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            Passport
                        </Typography>
                        <label htmlFor="passport-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="passport-upload"
                                type="file"
                                name="passport"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.passport?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Typography variant="body2" gutterBottom>
                            salary closure
                        </Typography>
                        <label htmlFor="salaryclose-upload">
                            <input
                                accept="application/pdf,image/*"
                                style={{ display: "none" }}
                                id="salaryclose-upload"
                                type="file"
                                name="salaryclose"
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="outlined"
                                component="span"
                                fullWidth
                            >
                                {formData.salaryclose?.originalName || "Upload File"}
                            </Button>
                        </label>
                    </Box>

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Button onClick={handleClose} variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSave}
                            variant="contained"
                            color="primary"
                            disabled={loading}
                            startIcon={loading && <CircularProgress size={20} color="inherit" />}
                        >
                            {loading ? "Saving..." : "Save"}
                        </Button>
                    </Box>
                </Paper>
            </Modal>

            {/* Modal for documents Details */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: "60%", md: "50%" },
                        maxHeight: "80vh",
                        bgcolor: "white",
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                        overflowY: "auto",
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
                    >
                        Sign-On Documents - {crewMeta?.name} - {crewMeta?.indos}
                    </Typography>

                    {selectedDocuments.length > 0 ? (
                        selectedDocuments.map((doc, index) => (
                            <Paper
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    p: 2,
                                    mb: 2,
                                    boxShadow: 2,
                                    borderRadius: 2,
                                    transition: "0.3s",
                                    "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                                }}
                            >
                                <Box display="flex" alignItems="center">
                                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                                    <Typography variant="body1">
                                        {doc.name || "Unnamed Document"}
                                    </Typography>
                                </Box>

                                {doc.filePath && doc.filePath.trim() !== "" ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href={doc.filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                        sx={{ textTransform: "none" }}
                                    >
                                        Download
                                    </Button>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No File Available
                                    </Typography>
                                )}
                            </Paper>
                        ))
                    ) : (
                        <Typography align="center" color="textSecondary">
                            No documents available
                        </Typography>
                    )}

                    <Box display="flex" justifyContent="center" mt={2}>
                        <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <TablePagination
                component="div"
                count={filteredContracts.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                sx={{
                    px: 2,
                    bgcolor: "#fafafa",
                    borderTop: "1px solid #e0e0e0",
                    display: "flex",
                    justifyContent: "flex-end"
                }}
            />
            <ToastContainer />
        </>
    );
};

export default SignOnModal;
